import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const createTenderItem = createAsyncThunk("createTenderItem", async ({ tenderId, payload }, { rejectWithValue }) => {
     try {
          const response = await axiosHttp.post(`tms/tenders/${tenderId}/items`, payload);
          return response.data;
     } catch (err) {
          if (!err.response) throw err;
          return rejectWithValue(err.response.data);
     }
});

export const getTenderStatus = createAsyncThunk("getTenderStatus", async (_, { rejectWithValue }) => {
     try {
          const response = await axiosHttp.get("category/list?identifier=tenders&limit=10&page=1");
          return Array.isArray(response?.data?.data?.docs) ? response.data.data.docs : [];
     } catch (err) {
          if (!err.response) throw err;
          return rejectWithValue(err.response.data);
     }
});


const TenderItemCreateSlice = createSlice({
     name: "TenderItemCreateSlice",
     initialState: {
          isLoading: false,
          data: null,
          error: null,
     },
     reducers: {
          resetTenderItemCreate: (state) => {
               state.isLoading = false;
               state.data = null;
               state.error = null;
          },
     },
     extraReducers: (builder) => {
          builder.addCase(createTenderItem.pending, (state) => {
               state.isLoading = true;
               state.error = null;
          });
          builder.addCase(createTenderItem.fulfilled, (state, action) => {
               state.isLoading = false;
               state.data = action.payload?.data;
          });
          builder.addCase(createTenderItem.rejected, (state, action) => {
               state.isLoading = false;
               state.error = action.payload?.data;
          });

          builder.addCase(getTenderStatus.pending, (state) => {
               state.tenderStatusLoading = true;
               state.tenderStatusError = null;
          });
          builder.addCase(getTenderStatus.fulfilled, (state, action) => {
               state.tenderStatusLoading = false;
               state.tenderStatus = action.payload;
          });
          builder.addCase(getTenderStatus.rejected, (state, action) => {
               state.tenderStatusLoading = false;
               state.tenderStatusError = action.payload?.data;
          });
     },
});

export const { resetTenderItemCreate } = TenderItemCreateSlice.actions;
export const { resetTenderStatus } = TenderItemCreateSlice.actions;
export default TenderItemCreateSlice.reducer;

